<div class="flex flex-col h-full">
  <app-dynamic-grid
    #dynamicGrid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [editDataUrl]="editDataUrl"
    [addDataUrl]="addDataUrl"
    [toggleUrl]="toggleUrl"
    [sortBy]="'modifiedAt'"
    [sortOrder]="'desc'"
    (addClicked)="onAddHandler()"
    (editClicked)="onEditHandler($event)"
    (onToggleShowToastEmitter)="showToast($event)"
  ></app-dynamic-grid>

  <app-drawer
    #drawer
    [drawerModel]="pmsSchemaIntegrity"
    [drawerConfig]="drawerInputConfig"
    [editDataURL]="editDataUrl"
    [AddDataURL]="addDataUrl"
    drawerModelName="pmsSchemaIntegrity"
    createDrawerTitle="Add PMS Schema Integrity"
    updateDrawerTitle="Update PMS Schema Integrity"
    (refresh)="refreshHandler()"
    (resetData)="resetEntry()"
  ></app-drawer>

  <app-toast #toast></app-toast>
</div>